import authStore from "stores/authStore";
import { ClaimResource } from "types/claimTypes";

type ClaimBasedComponentProps = {
  children: React.ReactNode;
  requestedClaims: ClaimResource[];
};

export const ClaimBasedComponent = ({
  children,
  requestedClaims,
}: ClaimBasedComponentProps) => {
  const { isLoggedIn, claims } = authStore.useState((s) => ({
    isLoggedIn: s.isLoggedIn,
    claims: s.claims,
  }));

  const hasPermission =
    isLoggedIn &&
    claims?.some((x) =>
      requestedClaims.some((claim) => x?.claimResource === claim)
    );

  if (!hasPermission) return null;

  return <>{children}</>;
};
